







































import Vue from "vue";
import Component from "vue-class-component";
import { LoadingSpinnerService } from "@/store";
import ApiFactory from "@/api/ApiFactory";
import {
  ClientListRowDto,
  BrokerDetailsDto
} from "@/api/ClientPortalApiClient";
import { BvTableField } from "bootstrap-vue";
import { FormatDate } from "@/filters/FormatDate";
import router, { ROUTES } from "@/router";

@Component
export default class BrokerHome extends Vue {
  private broker: BrokerDetailsDto | null = null;
  private clients: ClientListRowDto[] = [];
  private fields = [
    {
      key: "id",
      tdClass: ["d-none", "d-md-block"],
      thClass: ["d-none", "d-md-block"]
    },
    {
      key: "firstName",
      sortable: true
    },
    {
      key: "lastName",
      sortable: true
    },
    {
      key: "dateOfBirth",
      sortable: false,
      formatter: this.formatDob,
      filterByFormatted: true
    },
    {
      key: "addressLine_1",
      sortable: false,
      tdClass: ["d-none", "d-md-block"],
      thClass: ["d-none", "d-md-block"]
    },
    {
      key: "status",
      sortable: true
    }
  ];
  private filterString: string = "";

  async created() {
    setTimeout(async () => {
      LoadingSpinnerService.Show("Loading clients...");
      try {
        await this.GetClientList();
        await this.GetBrokerDetails();
        LoadingSpinnerService.Hide();
      } catch (e) {
        LoadingSpinnerService.Failure(
          "Unable to load clients. Please try again."
        );
      }
    }, 100);
  }
  private async DownloadAUMReport() {
    LoadingSpinnerService.Show("Creating AUM Report...");
    try {
      const api = ApiFactory.CreateDataClient();
      const data = await api.externalBroker_DownloadAUMReport();
      if (data.data && data.fileName) {
        var bytes = this.base64ToArrayBuffer(data.data);
        const blob = new Blob([bytes], { type: data.contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var fileName = data.fileName;
        link.download = fileName;
        LoadingSpinnerService.Hide();
        link.click();
      }
    } catch (error) {
      LoadingSpinnerService.Failure("Something went wrong. Please try again.");
    }
  }
  private base64ToArrayBuffer(base64: string) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
  private async GetClientList() {
    const api = ApiFactory.CreateDataClient();
    this.clients = (await api.externalBroker_GetBrokerClientList()) || [];
  }

  private async GetBrokerDetails() {
    const api = ApiFactory.CreateDataClient();
    this.broker = await api.externalBroker_GetBrokerDetails();
  }

  get brokerName(): string | undefined {
    return this.broker !== null ? this.broker.name : "";
  }

  get brokerAgency(): string | undefined {
    return this.broker !== null ? this.broker.agencyCode : "";
  }

  private formatDob(
    value: object,
    key: string,
    item: ClientListRowDto
  ): string {
    return FormatDate.format(item.dateOfBirth.toString());
  }

  private onRowSelected(items: ClientListRowDto[]) {
    const selected = items[0];
    router.push({
      name: ROUTES.policies,
      params: { contactId: selected.id.toString() }
    });
  }
}
